import { themeMode } from '@juvare/common-web-ui/JuvareTheme';
import { Box } from '@mui/material';
import React from 'react';
import { loadScript } from '../../utils/loadScript';
const arcgisVersion = '4.30';
/**
 * This Component loads Arcgis CDN modules https://developers.arcgis.com/javascript/latest/get-started-cdn/
 * Waits for scripts to be loaded and then renders children.
 *
 * @param {PropsWithChildren} root0 - React props with optional children.
 * @param {React.ReactNode} root0.children - Elements to render once the ArcGIS scripts are loaded.
 * @returns {JSX.Element} A loading state, error message, or the rendered children with ArcGIS CSS included.
 */
export const ArcgisCdn = ({ children }) => {
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);
    React.useEffect(() => {
        Promise.all([
            loadScript(`https://js.arcgis.com/${arcgisVersion}/`),
            loadScript(`https://js.arcgis.com/map-components/${arcgisVersion}/arcgis-map-components.esm.js`, {
                type: 'module',
            }),
        ])
            .then(() => setLoaded(true))
            .catch(() => setError(true));
    }, []);
    if (loaded) {
        return (React.createElement(React.Fragment, null,
            React.createElement("link", { rel: 'stylesheet', type: 'text/css', href: `https://js.arcgis.com/${arcgisVersion}/esri/themes/${themeMode}/main.css` }),
            children));
    }
    else if (error) {
        return React.createElement(Box, null, "Error loading ArcGIS");
    }
    else {
        return React.createElement(Box, null, "Loading...");
    }
};
